import {
  RESET_FORM,
  SAVE_STEP_DATA,
  SET_STEP,
} from "../constants/invitesContants";

const initialState = {
  step: 1,
  formData: {
    step1: {},
    step2: {},
    step3: {},
  },
};

export const stepDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STEP:
      return {
        ...state,
        step: action.payload,
      };
    case SAVE_STEP_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.step]: action.payload.data,
        },
      };
    case RESET_FORM:
      return initialState;
    default:
      return state;
  }
};
